// Equipment positions: carts (bag carts) and beltloaders, scattered
// near gates and around the apron. Mock for now; would come from a
// real equipment-tracking system. Visible on the map when the
// equipment layer is enabled and zoom is high enough.

import { GATES } from './mockLiveState';

function makeRng(seed) {
  let s = seed >>> 0;
  return () => {
    s = (s + 0x6D2B79F5) >>> 0;
    let t = s;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

const rng = makeRng(98765);
function pick(arr) { return arr[Math.floor(rng() * arr.length)]; }
function rand(lo, hi) { return Math.floor(rng() * (hi - lo + 1)) + lo; }

// Each piece has: id, kind (cart|beltloader), gateId (parking gate),
// status (idle|in_use|broken).
const STATUS = ['idle', 'in_use', 'in_use', 'in_use', 'idle', 'broken'];

function buildEquipment() {
  const out = [];
  // 1-2 belt loaders per ~half the gates
  GATES.forEach(g => {
    if (rng() < 0.5) {
      out.push({
        id: `bl-${g.num}-${rand(100, 999)}`,
        kind: 'beltloader',
        gateId: g.id,
        status: pick(STATUS),
      });
    }
  });
  // 1-3 cart strings near most gates
  GATES.forEach(g => {
    const n = rand(0, 3);
    for (let i = 0; i < n; i++) {
      out.push({
        id: `c-${g.num}-${i}-${rand(100, 999)}`,
        kind: 'cart',
        gateId: g.id,
        status: pick(STATUS),
      });
    }
  });
  return out;
}

export const EQUIPMENT = buildEquipment();

export const EQUIPMENT_COLORS = {
  idle:   { fill: 'rgba(148, 163, 184, 0.85)', border: '#94A3B8' },
  in_use: { fill: 'rgba(0, 188, 212, 0.85)',  border: '#00BCD4' },
  broken: { fill: 'rgba(255, 0, 0, 0.85)',   border: '#FF0000' },
};
